import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

import { helpers } from 'styles'

import { Container } from './Container'

export const Line = styled.div`
	background-color: ${helpers.color.border};
	width: 1px;
	position: absolute;
	left: 18px;
	top: 38px;
	bottom: 0;

	${Container}:last-of-type & {
		display: none;
	}

	${mobileMediaQuery(css`
		left: 16px;
		top: 32px;
	`)}
`
